import { Tabs, TabsList, TabsTrigger } from '@Components/Tabs';
import { cn } from '@Utils/cn';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSms,
  faMobileAlt,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';

export type MessageChannel = 'SMS' | 'APP' | 'EMAIL';

interface ChannelOption {
  value: MessageChannel;
  label: string;
  icon: typeof faSms;
  disabled?: boolean;
}

const channelOptions: ChannelOption[] = [
  { value: 'SMS', label: 'SMS', icon: faSms },
  { value: 'APP', label: 'In-App', icon: faMobileAlt },
  { value: 'EMAIL', label: 'Email', icon: faEnvelope },
];

interface InboxChannelSelectorProps {
  selectedChannel: MessageChannel;
  onChannelChange: (channel: MessageChannel) => void;
  className?: string;
}

export function InboxChannelSelector({
  selectedChannel,
  onChannelChange,
  className,
}: InboxChannelSelectorProps) {
  return (
    <Tabs
      value={selectedChannel}
      onValueChange={(value) => onChannelChange(value as MessageChannel)}
      className={cn('w-full', className)}
    >
      <TabsList className="w-full justify-start">
        {channelOptions.map((option) => (
          <TabsTrigger
            key={option.value}
            value={option.value}
            disabled={option.disabled}
            className={cn(
              'flex items-center gap-2',
              option.disabled && 'cursor-not-allowed opacity-50',
            )}
          >
            <FontAwesomeIcon icon={option.icon} className="h-4 w-4" />
            <span>{option.label}</span>
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}

export default InboxChannelSelector;
